import React from 'react'
import Style from './createConnector.module.css'
import ConnectorLogo from '../../SharedComponents/ConnectorCard/ConnectorLogo'

const SystemTile = ({ system, isSelected, onSelect }) => (
    <button
        type="button"
        className={[Style.tile, isSelected ? Style.tileSelected : ''].join(' ')}
        aria-pressed={Boolean(isSelected)}
        disabled={!system.isAvailable}
        onClick={() => onSelect(system)}
    >
        <ConnectorLogo src={system.image} name={system.shortName} size="md" />
        <span className={Style.tileText}>
            <span className={Style.tileName} title={system.name}>{system.name}</span>
            <span className={Style.tileMeta}>{system.isAvailable ? system.categoryLabel : 'Coming soon'}</span>
        </span>
        {isSelected ? <i className={`uil-check-circle ${Style.tileCheck}`} aria-hidden="true" /> : null}
    </button>
)

export default SystemTile
